import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorDisputeNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IDisputeModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IDisputeFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useDisputeHookNae(id: number) : IDisputeModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorDisputeNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "dispute",
        fields: IDisputeFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
